// Forms module for ChatWidget - handles user details and appointment forms
import { validatePhoneNumber, validateEmail, formatPhoneNumber, formatPhoneNumberRealTime } from '../utils/helpers.js';
import { scrollToShowRecentMessages, scrollToBottom } from './ui.js';

// Get user details form HTML
export function getUserDetailsFormHTML(config, t) {
    return `
        <div class="user-details-form" id="userDetailsForm">
            <div class="user-details-field">
                <input type="text" id="userName" class="user-details-input" placeholder="${t('FORM_YOUR_NAME')}" />
                <div class="user-details-error" id="nameError">${t('FORM_NAME_REQUIRED')}</div>
            </div>

            <div class="user-details-field">
                <div class="user-details-phone-wrapper">
                    <div class="user-details-country-code">🇨🇦 +1</div>
                    <input type="tel" id="userPhone" class="user-details-input user-details-phone-input" placeholder="${t('FORM_PHONE_PLACEHOLDER')}" />
                </div>
                <div class="user-details-error" id="phoneError">${t('FORM_PHONE_OR_EMAIL_REQUIRED')}</div>
            </div>

            <div class="user-details-field">
                <input type="email" id="userEmail" class="user-details-input" placeholder="${t('FORM_EMAIL_PLACEHOLDER')}" />
                <div class="user-details-error" id="emailError">${t('FORM_PHONE_OR_EMAIL_REQUIRED')}</div>
            </div>

            <div class="user-details-consent">
                <input type="checkbox" id="userConsent" />
                <label for="userConsent">${t('FORM_CONSENT_LABEL')}</label>
                <div class="user-details-error" id="consentError">${t('FORM_CONSENT_REQUIRED')}</div>
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="declineUserDetails">${t('FORM_DECLINE')}</button>
                <button class="user-details-btn user-details-submit" id="submitUserDetails">${t('FORM_SEND')}</button>
            </div>
        </div>
    `;
}

// Get email-only form HTML
export function getEmailFormHTML(config, t) {
    return `
        <div class="user-details-form" id="emailForm">
            <div class="user-details-field">
                <input type="text" id="userName" class="user-details-input" placeholder="${t('FORM_YOUR_NAME')}" />
                <div class="user-details-error" id="nameError">${t('FORM_NAME_REQUIRED')}</div>
            </div>

            <div class="user-details-field">
                <input type="email" id="userEmail" class="user-details-input" placeholder="${t('FORM_EMAIL_PLACEHOLDER')} *" />
                <div class="user-details-error" id="emailError">${t('FORM_EMAIL_REQUIRED')}</div>
            </div>

            <div class="user-details-consent">
                <input type="checkbox" id="userConsent" />
                <label for="userConsent">${t('FORM_CONSENT_LABEL')}</label>
                <div class="user-details-error" id="consentError">${t('FORM_CONSENT_REQUIRED')}</div>
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="declineEmail">${t('FORM_DECLINE')}</button>
                <button class="user-details-btn user-details-submit" id="submitEmail">${t('FORM_SEND')}</button>
            </div>
        </div>
    `;
}

// Get phone-only form HTML
export function getPhoneFormHTML(config, t) {
    return `
        <div class="user-details-form" id="phoneForm">
            <div class="user-details-field">
                <input type="text" id="userName" class="user-details-input" placeholder="${t('FORM_YOUR_NAME')}" />
                <div class="user-details-error" id="nameError">${t('FORM_NAME_REQUIRED')}</div>
            </div>

            <div class="user-details-field">
                <div class="user-details-phone-wrapper">
                    <div class="user-details-country-code">🇨🇦 +1</div>
                    <input type="tel" id="userPhone" class="user-details-input user-details-phone-input" placeholder="${t('FORM_PHONE_PLACEHOLDER')} *" />
                </div>
                <div class="user-details-error" id="phoneError">${t('FORM_PHONE_REQUIRED')}</div>
            </div>

            <div class="user-details-consent">
                <input type="checkbox" id="userConsent" />
                <label for="userConsent">${t('FORM_CONSENT_LABEL')}</label>
                <div class="user-details-error" id="consentError">${t('FORM_CONSENT_REQUIRED')}</div>
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="declinePhone">${t('FORM_DECLINE')}</button>
                <button class="user-details-btn user-details-submit" id="submitPhone">${t('FORM_SEND')}</button>
            </div>
        </div>
    `;
}

// Get email confirmation HTML (for existing email)
export function getEmailConfirmationHTML(name, email, t) {
    return `
        <div class="user-details-form" id="emailConfirmation">
            <div class="user-details-intro">
                ${t('FORM_CONTACT_ON_FILE')}
            </div>

            <div class="user-details-summary">
                <div class="user-details-summary-item">
                    <strong>${t('FORM_NAME')}</strong> ${name}
                </div>
                <div class="user-details-summary-item">
                    <strong>${t('FORM_EMAIL')}</strong> ${email}
                </div>
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="updateEmail">${t('FORM_UPDATE')}</button>
                <button class="user-details-btn user-details-submit" id="confirmEmail">${t('FORM_CONFIRM')}</button>
            </div>
        </div>
    `;
}

// Get phone confirmation HTML (for existing phone)
export function getPhoneConfirmationHTML(name, phone, t) {
    return `
        <div class="user-details-form" id="phoneConfirmation">
            <div class="user-details-intro">
                ${t('FORM_CONTACT_ON_FILE')}
            </div>

            <div class="user-details-summary">
                <div class="user-details-summary-item">
                    <strong>${t('FORM_NAME')}</strong> ${name}
                </div>
                <div class="user-details-summary-item">
                    <strong>${t('FORM_PHONE')}</strong> ${phone}
                </div>
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="updatePhone">${t('FORM_UPDATE')}</button>
                <button class="user-details-btn user-details-submit" id="confirmPhone">${t('FORM_CONFIRM')}</button>
            </div>
        </div>
    `;
}

// Get user details confirmation HTML (for existing user details)
export function getUserDetailsConfirmationHTML(userDetails, t) {
    // Build contact info display
    let contactInfo = '';
    if (userDetails.phone) {
        contactInfo += `<div class="user-details-summary-item">
            <strong>${t('FORM_PHONE')}</strong> ${userDetails.phone}
        </div>`;
    }
    if (userDetails.email) {
        contactInfo += `<div class="user-details-summary-item">
            <strong>${t('FORM_EMAIL')}</strong> ${userDetails.email}
        </div>`;
    }

    // Combine firstName and lastName if they exist, otherwise use name field
    const fullName = userDetails.name || `${userDetails.firstName} ${userDetails.lastName}`;

    return `
        <div class="user-details-form" id="userDetailsConfirmation">
            <div class="user-details-intro">
                ${t('FORM_CONTACT_ON_FILE')}
            </div>

            <div class="user-details-summary">
                <div class="user-details-summary-item">
                    <strong>${t('FORM_NAME')}</strong> ${fullName}
                </div>
                ${contactInfo}
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="updateUserDetails">${t('FORM_UPDATE')}</button>
                <button class="user-details-btn user-details-submit" id="confirmUserDetails">${t('FORM_CONFIRM')}</button>
            </div>
        </div>
    `;
}

// Get submitted user details summary HTML (non-editable display after submission)
export function getUserDetailsSubmittedHTML(userDetails, t) {
    // Build contact info display
    let contactInfo = '';
    if (userDetails.phone) {
        contactInfo += `<div class="user-details-summary-item">
            <strong>${t('FORM_PHONE')}</strong> ${userDetails.phone}
        </div>`;
    }
    if (userDetails.email) {
        contactInfo += `<div class="user-details-summary-item">
            <strong>${t('FORM_EMAIL')}</strong> ${userDetails.email}
        </div>`;
    }

    // Combine firstName and lastName if they exist, otherwise use name field
    const fullName = userDetails.name || `${userDetails.firstName} ${userDetails.lastName}`;

    return `
        <div class="user-details-form" id="userDetailsSubmitted" style="opacity: 0.85;">
            <div class="user-details-summary">
                <div class="user-details-summary-item">
                    <strong>${t('FORM_NAME')}</strong> ${fullName}
                </div>
                ${contactInfo}
            </div>
        </div>
    `;
}

// Get appointment form HTML
export function getAppointmentFormHTML(userDetails, t) {
    return `
        <div class="user-details-form" id="appointmentForm">
            <div class="user-details-field">
                <label for="appointmentDate">${t('FORM_PREFERRED_DATE')}</label>
                <input
                    type="date"
                    id="appointmentDate"
                    class="user-details-input"
                    min="${new Date().toISOString().split('T')[0]}"
                    required>
                <span class="user-details-error" id="dateError"></span>
            </div>

            <div class="user-details-field">
                <label for="appointmentTime">${t('FORM_PREFERRED_TIME')}</label>
                <input
                    type="time"
                    id="appointmentTime"
                    class="user-details-input"
                    required>
                <span class="user-details-error" id="timeError"></span>
            </div>

            <div class="user-details-actions">
                <button class="user-details-btn user-details-decline" id="declineAppointment">${t('FORM_CANCEL')}</button>
                <button class="user-details-btn user-details-submit" id="submitAppointment">${t('FORM_SCHEDULE_APPOINTMENT')}</button>
            </div>
        </div>
    `;
}

// Setup event listeners for user details form fields
export function setupUserDetailsFormListeners(shadowRoot) {
    const nameInput = shadowRoot.getElementById('userName');
    const phoneInput = shadowRoot.getElementById('userPhone');
    const emailInput = shadowRoot.getElementById('userEmail');

    // Clear errors on input
    nameInput.addEventListener('input', () => {
        nameInput.classList.remove('error');
        shadowRoot.getElementById('nameError').classList.remove('visible');
    });

    // Phone input: clear errors AND format in real-time
    phoneInput.addEventListener('input', (e) => {
        phoneInput.classList.remove('error');
        shadowRoot.getElementById('phoneError').classList.remove('visible');

        // Format phone number as user types
        const cursorPosition = e.target.selectionStart;
        const oldValue = e.target.value;
        const oldLength = oldValue.length;

        const formattedValue = formatPhoneNumberRealTime(oldValue);
        e.target.value = formattedValue;

        // Adjust cursor position after formatting
        const newLength = formattedValue.length;
        const lengthDiff = newLength - oldLength;

        // If the formatted value is longer (e.g., added parenthesis or dash),
        // move the cursor forward
        if (lengthDiff > 0 && cursorPosition < newLength) {
            e.target.setSelectionRange(cursorPosition + lengthDiff, cursorPosition + lengthDiff);
        } else {
            e.target.setSelectionRange(cursorPosition, cursorPosition);
        }
    });

    emailInput.addEventListener('input', () => {
        emailInput.classList.remove('error');
        shadowRoot.getElementById('emailError').classList.remove('visible');
    });

    // Clear consent error when checkbox is changed
    const consentCheckbox = shadowRoot.getElementById('userConsent');
    const consentError = shadowRoot.getElementById('consentError');
    if (consentCheckbox && consentError) {
        consentCheckbox.addEventListener('change', () => {
            if (consentCheckbox.checked) {
                consentError.classList.remove('visible');
            }
        });
    }
}

// Setup event listeners for phone-only form
export function setupPhoneFormListeners(shadowRoot) {
    const phoneInput = shadowRoot.getElementById('userPhone');

    if (!phoneInput) {
        console.error('Phone input not found in phone form');
        return;
    }

    // Phone input: clear errors AND format in real-time
    phoneInput.addEventListener('input', (e) => {
        phoneInput.classList.remove('error');
        const phoneError = shadowRoot.getElementById('phoneError');
        if (phoneError) {
            phoneError.style.display = 'none';
        }

        // Format phone number as user types
        const cursorPosition = e.target.selectionStart;
        const oldValue = e.target.value;
        const oldLength = oldValue.length;

        const formattedValue = formatPhoneNumberRealTime(oldValue);
        e.target.value = formattedValue;

        // Adjust cursor position after formatting
        const newLength = formattedValue.length;
        const lengthDiff = newLength - oldLength;

        // If the formatted value is longer (e.g., added parenthesis or dash),
        // move the cursor forward
        if (lengthDiff > 0 && cursorPosition < newLength) {
            e.target.setSelectionRange(cursorPosition + lengthDiff, cursorPosition + lengthDiff);
        } else {
            e.target.setSelectionRange(cursorPosition, cursorPosition);
        }
    });

    // Clear consent error when checkbox is changed
    const consentCheckbox = shadowRoot.getElementById('userConsent');
    const consentError = shadowRoot.getElementById('consentError');
    if (consentCheckbox && consentError) {
        consentCheckbox.addEventListener('change', () => {
            if (consentCheckbox.checked) {
                consentError.classList.remove('visible');
            }
        });
    }
}

// Setup event listeners for appointment form fields
export function setupAppointmentFormListeners(shadowRoot, userDetails) {
    const dateInput = shadowRoot.getElementById('appointmentDate');
    const timeInput = shadowRoot.getElementById('appointmentTime');

    dateInput.addEventListener('input', () => {
        dateInput.classList.remove('error');
        shadowRoot.getElementById('dateError').classList.remove('visible');
    });

    timeInput.addEventListener('input', () => {
        timeInput.classList.remove('error');
        shadowRoot.getElementById('timeError').classList.remove('visible');
    });
}

// Validate user details form
export function validateUserDetailsForm(shadowRoot) {
    const nameInput = shadowRoot.getElementById('userName');
    const phoneInput = shadowRoot.getElementById('userPhone');
    const emailInput = shadowRoot.getElementById('userEmail');

    const name = nameInput?.value?.trim();
    const phone = phoneInput?.value?.trim();
    const email = emailInput?.value?.trim();

    let hasError = false;

    if (!name) {
        nameInput.classList.add('error');
        shadowRoot.getElementById('nameError').classList.add('visible');
        hasError = true;
    }

    // Either phone OR email must be provided
    if (!phone && !email) {
        phoneInput.classList.add('error');
        shadowRoot.getElementById('phoneError').classList.add('visible');
        emailInput.classList.add('error');
        shadowRoot.getElementById('emailError').classList.add('visible');
        hasError = true;
    } else {
        // If phone is provided, validate it
        if (phone && !validatePhoneNumber(phone)) {
            phoneInput.classList.add('error');
            shadowRoot.getElementById('phoneError').textContent = 'Invalid phone number';
            shadowRoot.getElementById('phoneError').classList.add('visible');
            hasError = true;
        }
        // If email is provided, validate it
        if (email && !validateEmail(email)) {
            emailInput.classList.add('error');
            shadowRoot.getElementById('emailError').textContent = 'Invalid email';
            shadowRoot.getElementById('emailError').classList.add('visible');
            hasError = true;
        }
    }

    // Validate consent checkbox
    const consentCheckbox = shadowRoot.getElementById('userConsent');
    const consentError = shadowRoot.getElementById('consentError');
    if (consentCheckbox && !consentCheckbox.checked) {
        if (consentError) {
            consentError.classList.add('visible');
        }
        hasError = true;
    }

    if (hasError) {
        return null;
    }

    // Split name into firstName and lastName
    // First word is firstName, rest is lastName
    const nameParts = name.split(/\s+/);
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    return {
        name,
        firstName,
        lastName,
        phone: phone ? formatPhoneNumber(phone) : '',
        email,
        consent: consentCheckbox ? consentCheckbox.checked : true // Will always be true here since validation passed
    };
}

// Validate appointment form
export function validateAppointmentForm(shadowRoot, userDetails) {
    const dateInput = shadowRoot.getElementById('appointmentDate');
    const timeInput = shadowRoot.getElementById('appointmentTime');

    const date = dateInput.value.trim();
    const time = timeInput.value.trim();

    let hasError = false;

    // Validate date
    if (!date) {
        dateInput.classList.add('error');
        shadowRoot.getElementById('dateError').textContent = 'Date is required';
        shadowRoot.getElementById('dateError').classList.add('visible');
        hasError = true;
    }

    // Validate time
    if (!time) {
        timeInput.classList.add('error');
        shadowRoot.getElementById('timeError').textContent = 'Time is required';
        shadowRoot.getElementById('timeError').classList.add('visible');
        hasError = true;
    }

    if (hasError) {
        return null;
    }

    return {
        date,
        time
    };
}
